import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ResultsListStyled = styled(Box)(({ theme }) => ({
  // Base look only. Height (e.g. a maxHeight cap) is left to the consumer via
  // the panel's `listProps` — no cap → the list grows with its content.
  overflowY: 'auto',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));
